/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Sub_Addons_Confirm_Cancel_Schedule_DescInputs */



/**
* | output |
* | --- |
* | "Your storage will stay on {label}. The scheduled change will be canceled." |
*
* @param {Sub_Addons_Confirm_Cancel_Schedule_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_cancel_schedule_desc = /** @type {((inputs: Sub_Addons_Confirm_Cancel_Schedule_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Cancel_Schedule_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Speicher bleibt auf ${i?.label}. Die geplante Änderung wird abgebrochen.`)
	return /** @type {LocalizedString} */ (`Your storage will stay on ${i?.label}. The scheduled change will be canceled.`)
});